import { render } from "./ChartPieProject.vue?vue&type=template&id=76535f7d&scoped=true"
import script from "./ChartPieProject.vue?vue&type=script&lang=js"
export * from "./ChartPieProject.vue?vue&type=script&lang=js"

import "./ChartPieProject.vue?vue&type=style&index=0&id=76535f7d&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76535f7d"]])

export default __exports__